export default __webpack_public_path__ + "static/media/agreement-business-businessman.4d09024a.jpg";